import { log } from "./logging";
import { Action, OperatorData, UIElements } from "./wrapper-data";

export function patchInDebugWrapperFunctions(): void {
    const debugFunctions = {
        updateBalance,
        getOperatorGameiom,
        closeConnection,
        pauseGame,
        resumeGame,
        setMinStopDuration,
        setSlamStop,
        setDisplayWholeStakeAsDecimal,
        setHideJackpotWording,
        sendDebugMessage,
        setForce
    };
    (window as any).debugWrapper = debugFunctions;
    log(`Registered debugWrapper[${Object.keys(debugFunctions).join(", ")}]`);
}

function sendDebugMessage(action: Action, data?: Partial<OperatorData>): void {
    gameWrapper.onWrapperMessage(action, { action, data });
}

function setForce(force: string) {
    sendDebugMessage(Action.force, { name: force });
}

function pauseGame() {
    sendDebugMessage(Action.pauseGame);
}

function closeConnection(): void {
    gameWrapper.onWrapperMessage("closeGame", { action: "closeGame" });
}

function resumeGame() {
    sendDebugMessage(Action.resumeGame);
}

function updateBalance(cash: number, bonus = 0): void {
    sendDebugMessage(Action.updateBalance, { cash, bonus });
}

function setMinStopDuration(duration: number) {
    sendDebugMessage(Action.getOperatorInformation, { ui: { minStopDuration: duration } });
}

function setSlamStop(enabled: boolean) {
    sendDebugMessage(Action.getOperatorInformation, { ui: { slamStop: enabled ? "enabled" : "disabled" } });
}

function setDisplayWholeStakeAsDecimal(enabled: boolean) {
    sendDebugMessage(Action.getOperatorInformation, { ui: { displayWholeStakeAsDecimal: enabled ? "enabled" : "disabled" } });
}

function setHideJackpotWording(enabled: boolean) {
    sendDebugMessage(Action.getOperatorInformation, { ui: { hideJackpotWording: enabled ? "enabled" : "disabled" } });
}

function getOperatorGameiom(): void {
    sendDebugMessage(Action.getOperatorInformation, {
        "ui": {
            "layouts": {
                "mobile": [UIElements.depositPageButton, UIElements.homeButton],
                "desktop": []
            },
            "autoplay": {
                "numberOfRounds": {
                    "defaultVal": 20,
                    "values": [
                        20,
                        40,
                        80,
                        100
                    ]
                },
                "lossLimit": {
                    "defaultVal": 20000,
                    "values": [
                        5000,
                        10000,
                        20000,
                        50000,
                        100000
                    ],
                    "lossLimitRequired": true
                },
                "totalWinLimit": {
                    "defaultVal": 20000,
                    "values": [
                        5000,
                        10000,
                        20000,
                        50000,
                        100000
                    ]
                },
                "singleWinLimit": {
                    "defaultVal": 5000,
                    "values": [
                        0,
                        1000,
                        5000,
                        10000,
                        20000,
                        50000
                    ]
                },
                "stopOnFeatureWin": false
            },
            "maxBet": "enabled",
            "displayType": "credits",
            "displayClock": "enabled",
            "removeFromCurrencyString": "CAD",
            "slamStop": "enabled",
            "hideEnableSoundsPrompt": "disabled",
            "disableFullscreen": false,
            "denomDisplay": "denom",
            "hideJackpotWording": "enabled"
        }
    });
}
